export default __webpack_public_path__ + "static/media/termsOfUse.a7b59d49.pdf";